<app-window-title
  [title]="isEditMode ? 'Edit facility' : 'Create facility'"
  [closable]="true"
  (closed)="onCancel()">
</app-window-title>

<div class="form-container">
  <form
    [formGroup]="facilityForm"
    (ngSubmit)="onSubmit()">

    <!-- Facility ID / AE Title (edit mode only) -->
    <div *ngIf="isEditMode && data?.facility?.id" class="facility-id-row">
      ID: {{ data.facility.id }}<ng-container *ngIf="data?.facility?.aet"> / {{ data.facility.aet }}</ng-container>
    </div>

    <!-- Facility Name Field -->
    <div class="form-field-container">
      <mat-form-field
        class="full-width-field"
        appearance="outline">
        <mat-label> Name * </mat-label>
        <input
          matInput
          formControlName="name"
          required />
        <mat-error *ngIf="facilityForm.get('name')?.hasError('required') && facilityForm.get('name')?.touched">
          Name is required
        </mat-error>
      </mat-form-field>
    </div>

    <!-- Address Field -->
    <div class="form-field-container">
      <mat-form-field
        class="full-width-field"
        appearance="outline">
        <mat-label> Address * </mat-label>
        <textarea
          matInput
          formControlName="address"
          rows="3"
          required></textarea>
        <mat-error *ngIf="facilityForm.get('address')?.hasError('required') && facilityForm.get('address')?.touched">
          Address is required
        </mat-error>
      </mat-form-field>
    </div>

    <!-- Phone Number Field -->
    <div class="form-field-container">
      <mat-form-field
        class="full-width-field"
        appearance="outline">
        <mat-label> Phone number </mat-label>
        <input
          matInput
          formControlName="phoneNumber"
          type="tel" />
      </mat-form-field>
    </div>

    <!-- Email Address Field -->
    <div class="form-field-container">
      <mat-form-field
        class="full-width-field"
        appearance="outline">
        <mat-label> Email address </mat-label>
        <input
          matInput
          formControlName="emailAddress"
          type="email" />
        <mat-error
          *ngIf="facilityForm.get('emailAddress')?.hasError('email') && facilityForm.get('emailAddress')?.touched">
          Please enter a valid email address
        </mat-error>
      </mat-form-field>
    </div>

    <!-- Facility Type -->
    <div class="form-field-container">
      <mat-form-field
        class="full-width-field"
        appearance="outline">
        <mat-label>Facility type *</mat-label>
        <mat-select formControlName="planCode">
          <mat-option value="hub">Hub — central facility that initiates shares</mat-option>
          <mat-option value="spoke">Spoke — satellite facility that receives images</mat-option>
        </mat-select>
        <mat-error *ngIf="facilityForm.get('planCode')?.hasError('required') && facilityForm.get('planCode')?.touched">
          Facility type is required
        </mat-error>
      </mat-form-field>
    </div>

    <!-- Network Facility Link (Super User / edit mode only) -->
    <div
      *ngIf="isSuperUser && isEditMode"
      class="form-field-container">
      <mat-form-field
        class="full-width-field"
        appearance="outline">
        <mat-label>Network facility (Orthanc)</mat-label>
        <mat-select formControlName="orthancFacilityId">
          <mat-option [value]="null">— None —</mat-option>
          <mat-option
            *ngFor="let o of availableOrthancFacilities"
            [value]="o.id">
            {{ o.label }}&nbsp;<span style="opacity:0.6">({{ o.id }})</span>
          </mat-option>
        </mat-select>
        <mat-hint *ngIf="orthancLoading">Loading…</mat-hint>
        <mat-hint *ngIf="!orthancLoading">Link this facility to an Orthanc instance. Each instance can only be linked once.</mat-hint>
      </mat-form-field>
    </div>

    <!-- Action Buttons -->
    <div class="button-container">
      <button
        *ngIf="canDeactivate"
        mat-stroked-button
        color="warn"
        type="button"
        (click)="onDeactivate()"
        [disabled]="loading || deactivateLoading"
        style="margin-right: auto">
        <span
          *ngIf="deactivateLoading"
          style="display: inline-flex; align-items: center; margin-right: 8px">
          <mat-spinner
            diameter="16"
            mode="indeterminate"
            style="display: inline-block"></mat-spinner>
        </span>
        {{ isDisabled ? 'Reactivate' : 'Deactivate' }}
      </button>
      <button
        mat-button
        type="button"
        (click)="onCancel()"
        [disabled]="loading">
        Cancel
      </button>
      <button
        mat-flat-button
        color="warn"
        type="submit"
        [disabled]="facilityForm.invalid || loading">
        <span
          *ngIf="loading"
          style="display: inline-flex; align-items: center; margin-right: 8px">
          <mat-progress-spinner
            diameter="16"
            mode="indeterminate"
            style="display: inline-block"></mat-progress-spinner>
        </span>
        {{ loading ? (isEditMode ? 'Saving...' : 'Creating...') : (isEditMode ? 'Save changes' : 'Create facility') }}
      </button>
    </div>
  </form>
</div>
